export default {
  list_patients: "Lista de pacientes",
  register_patient: "Adicionar paciente",
  update_patient: "Atualizar paciente",
  find_patients: "Encontrar pacientes",
  search_patients_description:
    "Para encontrar os pacientes realize uma busca por CPF ou CNS, Nome, Data de nascimento ou Nome da mãe",
  no_patients: "Nenhum paciente encontrado",
  no_search_patients_description:
    "Não foi possível encontrar nenhum registro com os dados fornecidos. Verifique os campos preenchidos e tente novamente",
  patient_data: "Dados do paciente",
};
